<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
  >
  <div class="pointer d-flex justify-content-end d-lg-none d-md-none"  (click)="drawer.toggle()">
    <img src="../../assets/images/icons/cross.svg" alt="close">
  </div>
    <mat-toolbar class="d-none d-md-block">
      <img
        routerLink="/"
        src="assets/images/Layer_1.png"
        alt="logo"
        class="mwe-logo"
    /></mat-toolbar>
    <mat-nav-list [class.disabled]="isPopUpVisible" class="nav-list-responsive">
      <div>
      <ng-container
        *ngIf="roleName === 'SUPER_ADMIN' && accountName !== 'Staff'"
      >
        <ng-container *ngFor="let link of navLinks['super-admin']">
          <a
            mat-list-item
            [routerLink]="['/' + link.route]"
            [ngClass]="{ active: isActive(link.route) }"
            (click)="
              setHeaderLabel(link.label); toggleCategoryLevels(link.label); removePreviousSearch()
            "
            class="sidenav-nav-item"
          >
            <span *ngIf="!isMobileScreen"
              class="sidenav-nav-item-span"
              style="display: flex; align-items: center"
            >
              <img
                [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
                src="{{ link.icon }}"
                class="svg-color"
                [ngClass]="{ active: isActive(link.route) }"
                alt="icon"
              />
              {{ link.label }}
              <mat-icon
                *ngIf="link.children"
                class="sidenav-nav-item-icon"
                style="margin-left: auto"
                (click)="removePreviousSearch()"
              >
                {{
                  isExpanded(link.label)
                    ? "keyboard_arrow_up"
                    : "keyboard_arrow_down"
                }}
              </mat-icon>
            </span>
            <span *ngIf="isMobileScreen"
              class="sidenav-nav-item-span"
              style="display: flex; align-items: center"
              (click)="!link.children && drawer.toggle()"
            >
              <img
                [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
                src="{{ link.icon }}"
                class="svg-color"
                [ngClass]="{ active: isActive(link.route) }"
                alt="icon"
              />
              {{ link.label }}
              <mat-icon
                *ngIf="link.children"
                class="sidenav-nav-item-icon"
                style="margin-left: auto"
                (click)="removePreviousSearch()"
              >
                {{
                  isExpanded(link.label)
                    ? "keyboard_arrow_up"
                    : "keyboard_arrow_down"
                }}
              </mat-icon>
            </span>
          </a>

          <ng-container *ngIf="link.children && isExpanded(link.label)">
            <ng-container *ngFor="let child of link.children">
              <a
                mat-list-item
                [routerLink]="['/' + (child.route || '')]"
                [ngClass]="{ active: isActive(child.route || '') }"
                (click)="setHeaderLabel(child.label || ''); removePreviousSearch()"
                class="sidenav-nav-item sub-menu"
              >
                <span *ngIf="!isMobileScreen"
                  class="sidenav-nav-item-span sub-menu"
                  style="display: flex; align-items: center"
                >
                  <img
                    src="{{ child.icon }}"
                    class="svg-color"
                    [ngClass]="{ active: isActive(child.route) }"
                    alt="icon"
                    style="margin-right: 8px; margin-left: 8px"
                  />
                  {{ child.label || "" }}
                </span>
                <span *ngIf="isMobileScreen"
                  class="sidenav-nav-item-span sub-menu"
                  style="display: flex; align-items: center"
                  (click)="drawer.toggle()"
                >
                  <img
                    src="{{ child.icon }}"
                    class="svg-color"
                    [ngClass]="{ active: isActive(child.route) }"
                    alt="icon"
                    style="margin-right: 8px; margin-left: 8px"
                  />
                  {{ child.label || "" }}
                </span>
              </a>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

<ng-container *ngIf="roleName === 'DISTRIBUTOR' && accountName !== 'Staff'">
  <ng-container *ngFor="let link of navLinks['distributor']">
  
    <a *ngIf="!isPopUpVisible"
       mat-list-item
       [routerLink]="['/' + link.route]"
       [ngClass]="{ 'active': isActive(link.route) }"
       (click)="setHeaderLabel(link.label); toggleCategoryLevels(link.label); removePreviousSearch()"
       class="sidenav-nav-item">
    
      <span *ngIf="!isMobileScreen"
            class="sidenav-nav-item-span"
            style="display: flex; align-items: center">
        <img [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
             [src]="link.icon"
             class="svg-color"
             [ngClass]="{ 'active': isActive(link.route) }"
             alt="icon">
        {{ link.label }}
        <mat-icon *ngIf="link.children"
                  class="sidenav-nav-item-icon"
                  style="margin-left: auto;"
                  (click)="removePreviousSearch()">
          {{ isExpanded(link.label) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
      </span>
    
      <span *ngIf="isMobileScreen"
            class="sidenav-nav-item-span"
            style="display: flex; align-items: center"
            (click)="!link.children && drawer.toggle()">
        <img [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
             [src]="link.icon"
             class="svg-color"
             [ngClass]="{ 'active': isActive(link.route) }"
             alt="icon">
        {{ link.label }}
        <mat-icon *ngIf="link.children"
                  class="sidenav-nav-item-icon"
                  style="margin-left: auto;"
                  (click)="removePreviousSearch()">
          {{ isExpanded(link.label) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
      </span>
    </a>
  
    <a *ngIf="isPopUpVisible"
       mat-list-item
       [routerLink]="['/' + link.route]"
       [ngClass]="{ 'active': isActive(link.route) }"
       (click)="blockDashboard('distributor', link.label); toggleCategoryLevels(link.label); removePreviousSearch()"
       class="sidenav-nav-item">
    
      <span class="sidenav-nav-item-span"
            style="display: flex; align-items: center">
        <img [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
             [src]="link.icon"
             class="svg-color"
             [ngClass]="{ 'active': isActive(link.route) }"
             alt="icon">
        {{ link.label }}
        <mat-icon *ngIf="link.children"
                  class="sidenav-nav-item-icon"
                  style="margin-left: auto;"
                  (click)="removePreviousSearch()">
          {{ isExpanded(link.label) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
      </span>
    </a>

    <ng-container *ngIf="link.children && isExpanded(link.label) && !isPopUpVisible">
      <ng-container *ngFor="let child of link.children">
        <a mat-list-item
           [routerLink]="['/' + (child.route || '')]"
           [ngClass]="{ 'active': isActive(child.route || '') }"
           (click)="setHeaderLabel(child.label || ''); removePreviousSearch()"
           class="sidenav-nav-item sub-menu">
    
          <span *ngIf="!isMobileScreen"
                class="sidenav-nav-item-span sub-menu"
                style="display: flex; align-items: center;">
            <img [src]="child.icon"
                 class="svg-color"
                 [ngClass]="{ 'active': isActive(child.route) }"
                 alt="icon"
                 style="margin-right: 8px; margin-left: 5px">
            {{ child.label || '' }}
          </span>
    
          <span *ngIf="isMobileScreen"
                class="sidenav-nav-item-span sub-menu"
                style="display: flex; align-items: center"
                (click)="drawer.toggle()">
            <img [src]="child.icon"
                 class="svg-color"
                 [ngClass]="{ 'active': isActive(child.route) }"
                 alt="icon"
                 style="margin-right: 8px; margin-left: 5px">
            {{ child.label || '' }}
          </span>
        </a>
      </ng-container>
    </ng-container>

  </ng-container>
</ng-container>


      <ng-container *ngIf="roleName === 'OEM' && accountName !== 'Staff'">
        <ng-container *ngFor="let link of navLinks['oem']">
      
          <a *ngIf="!isPopUpVisible"
             mat-list-item
             [routerLink]="['/' + link.route]"
             [ngClass]="{ 'active': isActive(link.route) }"
             (click)="setHeaderLabel(link.label); toggleCategoryLevels(link.label); removePreviousSearch()"
             class="sidenav-nav-item">
      
            <span *ngIf="!isMobileScreen"
                  class="sidenav-nav-item-span"
                  style="display: flex; align-items: center;">
              <img [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
                   [src]="link.icon"
                   class="svg-color"
                   [ngClass]="{ 'active': isActive(link.route) }"
                   alt="icon">
              {{ link.label }}
              <mat-icon *ngIf="link.children"
                        class="sidenav-nav-item-icon"
                        style="margin-left: auto;"
                        (click)="removePreviousSearch()">
                {{ isExpanded(link.label) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </span>
      
            <span *ngIf="isMobileScreen"
                  class="sidenav-nav-item-span"
                  style="display: flex; align-items: center;"
                  (click)="!link.children && drawer.toggle()">
              <img [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
                   [src]="link.icon"
                   class="svg-color"
                   [ngClass]="{ 'active': isActive(link.route) }"
                   alt="icon">
              {{ link.label }}
              <mat-icon *ngIf="link.children"
                        class="sidenav-nav-item-icon"
                        style="margin-left: auto;"
                        (click)="removePreviousSearch()">
                {{ isExpanded(link.label) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </span>
          </a>
      
          <a *ngIf="isPopUpVisible"
             mat-list-item
             [routerLink]="['/' + link.route]"
             [ngClass]="{ 'active': isActive(link.route) }"
             (click)="blockDashboard('oem', link.label); toggleCategoryLevels(link.label); removePreviousSearch()"
             class="sidenav-nav-item">
      
            <span class="sidenav-nav-item-span"
                  style="display: flex; align-items: center;">
              <img [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
                   [src]="link.icon"
                   class="svg-color"
                   [ngClass]="{ 'active': isActive(link.route) }"
                   alt="icon">
              {{ link.label }}
              <mat-icon *ngIf="link.children"
                        class="sidenav-nav-item-icon"
                        style="margin-left: auto;"
                        (click)="removePreviousSearch()">
                {{ isExpanded(link.label) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </span>
          </a>
      
          <ng-container *ngIf="link.children && isExpanded(link.label) && !isPopUpVisible">
            <ng-container *ngFor="let child of link.children">
              <a mat-list-item
                 [routerLink]="['/' + (child.route || '')]"
                 [ngClass]="{ 'active': isActive(child.route || '') }"
                 (click)="setHeaderLabel(child.label || ''); removePreviousSearch()"
                 class="sidenav-nav-item sub-menu">
      
                <span *ngIf="!isMobileScreen"
                      class="sidenav-nav-item-span sub-menu"
                      style="display: flex; align-items: center;">
                  <img [src]="child.icon"
                       class="svg-color"
                       [ngClass]="{ 'active': isActive(child.route) }"
                       alt="icon"
                       style="margin-right: 8px; margin-left: 5px;">
                  {{ child.label || '' }}
                </span>
      
                <span *ngIf="isMobileScreen"
                      class="sidenav-nav-item-span sub-menu"
                      style="display: flex; align-items: center;"
                      (click)="drawer.toggle()">
                  <img [src]="child.icon"
                       class="svg-color"
                       [ngClass]="{ 'active': isActive(child.route) }"
                       alt="icon"
                       style="margin-right: 8px; margin-left: 5px;">
                  {{ child.label || '' }}
                </span>
              </a>
            </ng-container>
          </ng-container>
      
        </ng-container>
      </ng-container>
      
    </div>
      <div class="d-md-none d-lg-none profile-logout ">
        <button
        [routerLink]="getProfileRouteBasedOnRole(roleName)"
        (click)="setHeaderLabel('My Profile'); drawer.toggle()"
        class="profile"
      >
        <img src="\assets\images\user-circle-white.svg" alt="" style="margin-right:8px;"/>
        Profile
      </button>
      <button (click)="signOut()" class="logout-button">
        <img src="assets/images/icons/sign-out.svg" alt="" />
        Logout
      </button>
      </div>
      <ng-container *ngIf="accountName === 'Staff'">
        <ng-container *ngFor="let link of filteredMenu">
          <a
            mat-list-item
            [routerLink]="['/' + link.route]"
            [ngClass]="{ active: isActive(link.route) }"
            (click)="
              setHeaderLabel(link.label); toggleCategoryLevels(link.label)
            "
            class="sidenav-nav-item"
          >
            <span
              class="sidenav-nav-item-span"
              style="display: flex; align-items: center"
            >
              <img
                [style.margin-right.px]="link.label === 'Dashboard' ? 11 : 8"
                src="{{ link.icon }}"
                class="svg-color"
                [ngClass]="{ active: isActive(link.route) }"
                alt="icon"
              />
              {{ link.label }}
              <mat-icon
                *ngIf="link.children"
                class="sidenav-nav-item-icon"
                style="margin-left: auto"
              >
                {{
                  isExpanded(link.label)
                    ? "keyboard_arrow_up"
                    : "keyboard_arrow_down"
                }}
              </mat-icon>
            </span>
          </a>

          <ng-container *ngIf="link.children && isExpanded(link.label)">
            <ng-container *ngFor="let child of link.children">
              <a
                mat-list-item
                [routerLink]="['/' + (child.route || '')]"
                [ngClass]="{ active: isActive(child.route || '') }"
                (click)="setHeaderLabel(child.label || '')"
                class="sidenav-nav-item sub-menu"
              >
                <span
                  class="sidenav-nav-item-span sub-menu"
                  style="display: flex; align-items: center"
                >
                  <img
                    src="{{ child.icon }}"
                    class="svg-color"
                    [ngClass]="{ active: isActive(child.route) }"
                    alt="icon"
                    style="margin-right: 8px; margin-left: 5px"
                  />
                  {{ child.label || "" }}
                </span>
              </a>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
      <!-- Add more ng-container blocks for other roles -->
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary" class="toolbar">
      <button
        class="d-none d-md-block"
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async"
      >
      <img src="../../../../assets/images/menu.svg" alt="" class="more" style="border: none;">
      </button>
      <div class="header-container">
        <span class="component-heading">{{ headerLabel }}</span>
        <span class="breadcrumb-container">
          <nav *ngIf="breadcrumbs.length > 1">
            <ol class="breadcrumb">
              <ng-container
                *ngFor="let breadcrumb of breadcrumbs; let i = index"
              >
                <li
                  class="breadcrumb-item"
                  [class.breadCrumb-first-item]="i === 0"
                  [class.breadCrumb-second-item]="i !== 0"
                >
                  {{ breadcrumb }}
                </li>
              </ng-container>
            </ol>
          </nav>
        </span>
      </div>
      <img
      class="medworldexpoLogo d-md-none d-lg-none"
      src="./../../../assets/images/logomedworld32full.svg"
      alt="medworldexpo"
      style="height: 25px;width:97px; padding-left: 10px;"
      [routerLink]="['/']"
      />

      <div class="right-icons">
        <!-- <button mat-icon-button> -->
        <!-- <img src="assets/images/icons/settings-outlined.svg" alt=""> -->

        <!-- Notification Button -->
        <div
          class="notification-container d-none d-md-block"
          (mouseover)="toggleNotifications(true)"
          (mouseleave)="toggleNotifications(false)"
        >
          <button mat-icon-button style="margin-top: -10px">
            <img
              *ngIf="!noData"
              src="\assets\images\icons\notification-bell-icon.svg"
              alt="icon"
            />
            <img
              *ngIf="noData"
              src="\assets\images\bell_552872.svg"
              alt="icon"
            />
          </button>

          <div *ngIf="showNotificationDropdown" class="notification-dropdown">
            <h2>Notifications</h2>
            <div *ngIf="noData" class="notification-items">
              No Notifications
            </div>
            <div
              *ngFor="let notification of limitedNotifications"
              class="notification-item"
              style="cursor: pointer"
              (click)="openAllNotifications(notification)"
            >
              <!-- <p >{{ notification.content }}</p> -->
              <div
                class="d-flex flex-row align-items-start m-1 justify-content-center"
              >
                <img
                  src="\assets\images\email_4546924.svg"
                  alt=".."
                  height="14px"
                  width="14px"
                  style="margin-top: 3px; margin-right: 8px"
                />
                <p style="padding-top: 4px"><b>Subject:</b>&nbsp;</p>
                <p
                  style="margin-top: 1px; text-wrap: wrap; line-height: 20px"
                  [innerHTML]="notification.subject"
                ></p>
              </div>
            </div>
            <button mat-button (click)="openAllNotifications('')">
              Show All Notifications
            </button>
          </div>
        </div>

        <!-- <button mat-icon-button> -->
          <div class="user-profile-container">
        <img class="header-user-profile-pic" [src]="profilePhoto" alt="" />
        <!-- </button> -->
        <div class="container ">
          <div class="row">
            <span class="user-header-display-name">{{ userName }}</span>
          </div>
          <div class="row">
            <span class="user-header-display-role">{{ (roleName === 'SUPER_ADMIN' || 'OEM' || 'DISTRIBUTOR') && accountName === 'Staff' ? this.viewStaffData?.position : (roleName === 'SUPER_ADMIN' ? 'SUPER ADMIN' : roleName) }}</span>
          </div>
        </div>
        </div>
        <button style="color: #0D87C8"

        class=" d-md-none d-lg-none"
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async"
      >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
        <button mat-icon-button [matMenuTriggerFor]="menu" class="d-none d-md-block">
          <img src="assets/images/icons/caret-down.svg" alt="" />
        </button>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            [routerLink]="getProfileRouteBasedOnRole(roleName)"
            (click)="setHeaderLabel('My Profile')"
          >
            <img src="assets/images/icons/user-circle.svg" alt="" />
            Profile
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="signOut()" >
            <img src="assets/images/icons/sign-out.svg" alt="" />
            Logout
          </button>

        </mat-menu>
      </div>
    </mat-toolbar>
    <div class="dashboard">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
